import { Injectable } from '@angular/core';
import {
  KeySyncModel,
  KeySyncViewModel,
  KeyViewModel,
  NewKeyViewModel
} from "../system/admin-panel/Keys/Model/KeyViewModel";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { SyncService } from './sync.service';
import { ObjectGroupViewModel } from '../system/admin-panel/ObjectGroupViewModel';
import { Observable } from 'rxjs';

@Injectable()
export class KeysService {

  constructor(private client: HttpClient, private syncService: SyncService) {
  }

  public GetKeys(): Observable<KeyViewModel[]> {
    return this.client.get<KeyViewModel[]>("/ctrl/DriverKeys").pipe(map(values => {
      let result: KeyViewModel[] = [];
      if (values && values.constructor === Array) {
        for (let item of values) {
          let resultItem = KeyViewModel.fromJS(item)
          result.push(resultItem);
        }
      }

      return result;
    }))
  }
  public GetKey(id) {
    return this.client.get<any>("/ctrl/DriverKeys/" + id).pipe(map(value => {
      return KeyViewModel.fromJS(value);
    }))
  }

  public DeleteKey(id) {
    return this.client.delete("/ctrl/DriverKeys/" + id).pipe(map(() => {
      this.syncService.NotifyEntityChanged("Key", id);
    }));
  }

  public EditKey(model: KeyViewModel) {
    if (model.Id != 0)
      return this.client.put("/ctrl/DriverKeys", new NewKeyViewModel(model)).pipe(map(() => {
        this.syncService.NotifyEntityChanged("Key", model.Id);
      }));
  }

  public CreateKey(model: KeyViewModel) {
    return this.client.post("/ctrl/DriverKeys", new NewKeyViewModel(model)).pipe(map(() => {
      this.syncService.NotifyEntityChanged("Key", model.Id);
    }));
  }

  //////////////////////////////////////////////////////////////////////////////////////
  public ResyncKeys(model: KeySyncModel[]) {
    return this.client.put("/ctrl/keys/resync", model);
  }

  public GetSyncKeysForKey(targetId: number) {
    return this.client.get<any>("/ctrl/keys/sync/" + targetId).pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(KeySyncViewModel.fromJS(item, false))
      }
      return result;
    }))
  }

  public SetSyncKeysForKey(targetId: number, objectIds: number[]) {
    return this.client.put<any>("/ctrl/keys/sync/" + targetId, objectIds);
  }

  public ForceUnsyncKeys(model: KeySyncModel[]) {
    return this.client.put("/ctrl/keys/sync/ForceUnsyncKeys", model);
  }
  //////////////////////////////////////////////////////////////////////////////////////
  public ExportKeys(keys: KeyViewModel[]) {
    return this.client.post("/ctrl/keys/import", keys);
  }
  public ResetAbsBalance(id: number) {
    return this.client.get("/ctrl/keys/reset/" + id);
  }
  //////////////////////////////////////////////////////////////////
  public GetGroups() {
    return this.client.get<any>("/ctrl/DriverKeyGroups").pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array) {
        for (let item of values)
          result.push(ObjectGroupViewModel.fromJS(item))
      }
      return result;
    }));
  }

  public CreateGroup(input) {
    return this.client.post("/ctrl/DriverKeyGroups", input);
  }

  public DeleteGroup(input) {
    return this.client.delete("/ctrl/DriverKeyGroups/" + input.Id);
  }
}
